var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57327 1.87131L4.87962 0.177656C2.03712 2.34506 0.165812 5.68499 0 9.47499H2.36875C2.45264 7.97298 2.87427 6.50924 3.60224 5.19275C4.3302 3.87626 5.34575 2.74094 6.57327 1.87131V1.87131ZM21.2477 9.47499H23.6164C23.4388 5.68499 21.5674 2.34506 18.7368 0.177656L17.055 1.87131C18.2773 2.74522 19.2883 3.8818 20.0138 5.19758C20.7393 6.51336 21.1609 7.97494 21.2477 9.47499ZM18.9144 10.0672C18.9144 6.43115 16.9721 3.38731 13.5848 2.58193V1.77656C13.5848 0.79353 12.7912 0 11.8082 0C10.8252 0 10.0316 0.79353 10.0316 1.77656V2.58193C6.63249 3.38731 4.70196 6.41931 4.70196 10.0672V15.989L2.33322 18.3578V19.5422H21.2832V18.3578L18.9144 15.989V10.0672ZM11.8082 23.0953C11.974 23.0953 12.128 23.0834 12.282 23.0479C13.0518 22.8821 13.6795 22.361 13.9875 21.6504C14.1059 21.3661 14.1651 21.0582 14.1651 20.7265H9.42761C9.43946 22.0294 10.4936 23.0953 11.8082 23.0953Z",
    fill: "#5F1CCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.2c5a0983442745b90cd565b2feba18c8.svg";
export { ForwardRef as ReactComponent };